var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00015 4H9.00015C9.00015 4 9.00015 7 12.0002 7C15.0002 7 15.0002 4 15.0002 4H18.0002M18.0002 11V19.4C18.0002 19.5591 17.9369 19.7117 17.8244 19.8243C17.7119 19.9368 17.5593 20 17.4002 20H6.60015C6.44102 20 6.28841 19.9368 6.17589 19.8243C6.06337 19.7117 6.00015 19.5591 6.00015 19.4V11M18.0002 4L22.4432 5.777C22.5909 5.83615 22.7091 5.95155 22.7717 6.09783C22.8343 6.24411 22.8363 6.40927 22.7772 6.557L21.1512 10.623C21.1066 10.7343 21.0297 10.8297 20.9304 10.8969C20.8312 10.9641 20.714 11 20.5942 11H18.0002M6.00015 4L1.55715 5.777C1.40943 5.83615 1.29125 5.95155 1.22862 6.09783C1.16598 6.24411 1.16401 6.40927 1.22315 6.557L2.84915 10.623C2.89371 10.7343 2.97058 10.8297 3.06986 10.8969C3.16914 10.9641 3.28627 11 3.40615 11H6.00015",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.9f312c25557d92054c6b596ec76d1258.svg";
export { ForwardRef as ReactComponent };